<div class="modal-wrapper">
  @if (facultyService.classes$ | async; as academics) {
    <div>
      @if (academics.sectionsByGroup | classSyllabusFilter: section.CourseCode : section.SectionId; as sectionsByProgram ) {
        <div class="modal-header">
          <h4 tabindex="0" ngbAutofocus class="modal-title">
            Update Course Resources for {{section.SectionName}}
            ( {{academics.currentYear}} )
          </h4>
          <button type="button" class="btn-close" aria-label="Close" (click)="closeModal('Cross click', sectionsByProgram)">
          </button>
        </div>
        <div class="modal-body">
          <div class="card-body">
            <!-- Using an empty async here so we can trigger a modal result after the copy or upload-->
            @if (updatedSections$ | async) {
            }
            <div class="row">
              <!-- NEW SYLLABUS BUTTON -->
              <div class="col-md-6 col-sm-12 d-grid">
                <div [class.active]="active == 'upload'" (click)="toggleActiveButton('upload')" class="btn btn-outline-primary btn-block btn-syllabus file-upload-container">
                  <div>Upload new Course Resources (pdf):</div>
                  <input type="file" id="syllabusUpload" name="syllabusUpload"
                    accept=".pdf,application/pdf" [(ngModel)]="filename" (change)="updateFile($event)" />
                    <label for="syllabusUpload" class="custom-file-upload">
                      <i class="fa fa-cloud-upload"></i> Choose File
                    </label>
                    @if (uploadFileSizeError) {
                      <div class="mb-0 text-warning">Your file is too large, please limit to less than 4MB</div>
                    }
                  </div>
                </div>
                <!-- COPY SYLLABUS BUTTON -->
                @if (auth.hasFeature('SyllabusCopy')) {
                  <div class="col-md-6 col-sm-12 d-grid">
                    <div [class.active]="active == 'copy'" (click)="toggleActiveButton('copy')" class="btn btn-outline-primary btn-block btn-syllabus file-copy-container">
                      <div class="file-copy-text text-center">Copy Course Resources From Previous Section</div>
                    </div>
                  </div>
                }
              </div>
              @if (selectedFileName != '') {
                <div class="text-center">Uploaded File: {{selectedFileName}}</div>
              }
              <br />
              <h4 class="text-center">Select sections below:</h4>
              <div class="card card-fluid">
                @for (p of sectionsByProgram; track p) {
                  <div>
                    <header class="card-header drag-handle">{{p.program | uppercase}}</header>
                    <div class="list-group list-group-flush list-group-bordered">
                      @for (s of p.sections; track s; let i = $index) {
                        <div class="list-group-item justify-content-between align-items-center">
                          <bool-slider (returnInput)="toggleSection(p.sections[i].SectionId)"
                            [(container)]="p.sections[i]"
                            field="isSyllabusSelected"
                            [id]="p.sections[i].SectionId"
                            [labelText]="p.sections[i].SectionName + ': ' + s.Title + ' - ' + s.StartsInTermName"
                            [labelCols]="10"
                            [checkedLabel]="'Yes'"
                          [uncheckedLabel]="'No'"></bool-slider>
                        </div>
                      }
                    </div>
                  </div>
                }
              </div>
            </div>
            <div class="alert alert-warning mt-1">Course resources will be available for ALL STUDENTS to download from the course catalog.</div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-outline-secondary" (click)="closeModal('cancel', sectionsByProgram)">Cancel</button>
            <button type="button" class="btn btn-primary" (click)="uploadSyllabus(sectionsByProgram)"
                        [disabled]="(selectedSections.length == 0)
                        || ( (active == 'upload') && (uploadFileSizeError || !filename) )">
              Update {{selectedSections.length}} section @if (selectedSections.length == 0 || selectedSections.length > 1) {
              <span>s</span>
            }
            @if (uploading) {
              <span class="loader loader-sm loader-light" role="status" aria-hidden="true"></span>
            }
          </button>
        </div>
      }
    </div>
  }
  <ng-template #loading>
    <div class="widget-loading text-center">
      <i class="fas fa-circle-notch fa-spin"></i>
    </div>
  </ng-template>
</div>

